// src/components/ProjectHistoryDataGrid.jsx

import * as React from 'react';
import PropTypes from 'prop-types';
import { DataGridPremium } from '@mui/x-data-grid-premium';
import { Box, Button, Stack, createTheme, ThemeProvider, CssBaseline } from '@mui/material';
import { logColumns } from './ProjectHistoryDataGridColumns';
import ProjectHistoryFilters from './ProjectHistoryFilters';
import './ProjectHistory.css'; // Import the CSS file

const darkGridTheme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: '#000', // grid container background
      paper: '#1e1e1e', // inner surfaces
    },
  },
  components: {
    MuiDataGrid: {
      styleOverrides: {
        root: {
          border: 'none',
          backgroundColor: '#121212',
        },
        columnHeaders: {
          backgroundColor: '#1e1e1e',
        },
      },
    },
  },
});

export default function ProjectHistoryDataGrid({ logs, onClose, }) {
  const [selectionModel, setSelectionModel] = React.useState([]);
  const [filteredLogs, setFilteredLogs] = React.useState(logs);
  const [filterState, setFilterState] = React.useState({
    logType: '',
    category: '',
    entityId: '',
    modelType: ''
  });
  const handleRowSelection = (newSelection) => {
    setSelectionModel(newSelection);
  };

  const handleFilterChange = (filterName, filterValue) => {
    const newFilterState = {
      ...filterState,
      [filterName]: filterValue,
    };

    setFilterState(newFilterState);

    const updatedLogs = logs.filter((log) => {
      return (
        (!newFilterState.logType || log.type === newFilterState.logType) &&
        (!newFilterState.category || log.category === newFilterState.category) &&
        (!newFilterState.entityId || log.entityId === newFilterState.entityId) &&
        (!newFilterState.modelType || log.modelType === newFilterState.modelType)
      );
    });

    setFilteredLogs(updatedLogs);
  };

console.log('Rendering ProjectHistoryDataGrid with logs:', logs);
  return (
    <ThemeProvider theme={darkGridTheme}>
      <CssBaseline />
      <Box sx={{ p: 2, backgroundColor: 'background.default' }}>
        {/* Filters Section and Action Button on the Same Line */}
        <Stack direction="row" spacing={1} sx={{ mb: 1, alignItems: 'center' }} className="filter-container2">

          {/* Action Button */}
          <Button variant="contained" onClick={() => {}} disabled={!selectionModel.length}>
            DELETE
          </Button>

          {/* Filters Section */}
          <ProjectHistoryFilters logs={logs} onFilterChange={handleFilterChange} />

          <Box sx={{ flexGrow: 1 }} />
          
                    <Button variant="text" onClick={onClose}>
                      Close
                    </Button>
        </Stack>

        {/* DataGrid Section */}
        <div className="dataGridContainer">
          <DataGridPremium
            rows={filteredLogs}
            columns={logColumns}
            getRowId={(row) => row.id}
            pageSize={10}
            rowsPerPageOptions={[5, 10, 25]}
            disableSelectionOnClick
            checkboxSelection
            rowSelectionModel={selectionModel}
            onRowSelectionModelChange={handleRowSelection}
            initialState={{
              sorting: {
                sortModel: [{ field: 'createdAt', sort: 'desc' }],
              },
            }}
          />
        </div>
      </Box>
    </ThemeProvider>
  );
}

ProjectHistoryDataGrid.propTypes = {
  logs: PropTypes.arrayOf(PropTypes.object).isRequired,
};
